import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import App from './App';
import { getPageMetadata } from './routes';
import { initializeWebsiteAnalytics } from './lib/analytics';
import './index.css';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

initializeWebsiteAnalytics();

const app = (
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

const pathname = window.location.pathname.replace(/\/+$/, '') || '/';
const renderedPath = rootElement.dataset.pagePath;
// Case: matching page HTML (including the shared 404) can hydrate in place.
if (
  rootElement.hasChildNodes() &&
  (renderedPath === pathname ||
    (renderedPath === '/404.html' && getPageMetadata(pathname).noIndex))
) {
  ReactDOM.hydrateRoot(rootElement, app);
} else {
  // Case: development shells and the migration's old SPA fallback need a fresh
  // render, since a deep link may have received the homepage's HTML.
  ReactDOM.createRoot(rootElement).render(app);
}
